//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpControlGroup from './ControlGroup.vue';

export default {
  name: 'DpPageHeader',
  components: {
    DpControlGroup,
  },
  props: {
    flexibleHeight: { type: Boolean, default: false },
    attachToTop: { type: Boolean, default: true },
  },
};
